export const ORDER = {
  ID: 'id',
  DATE: 'locationPromisedTime',
  OLD_ORDER_ID: 'oldSauceOrderId',
  EXPIRED_TIME: 'cookingStartTime',
  AHEAD_TIME: 'aheadTime',
  REFUND: 'refunds',
  INVOICE_ID: 'invoiceId',
  ORDER_STATUS: 'internalOrderStatus',
  PRICE_ADJUSTMENTS: 'priceAdjustments',
  INTERNAL_NOTES: 'internalNotes',
  OVERDUE_DISABLED: 'overdueDisabled',
  CUSTOMER: 'customer',
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
  TOTALS: 'totals',
  SOURCE: 'source',
  BRAND: 'brand',
  TIPS_AMOUNT: 'tipsAmount',
  CART: 'cart',
  ORDER_TYPE: 'orderType',
  DISCOUNTS: 'discounts',
  TAXES: 'taxes',
  FEES: 'fees',
  PAYMENT_INTENT_ID: 'paymentIntentId',
  PAYMENT_METHOD: 'paymentMethod',
  CREATED_AT: 'createdAt',
  RECEIVED_AT: 'receivedAt',
  AMOUNT: 'amount',
  PAYMENT_TYPE: 'paymentType',
  EXTERNAL_ID: 'externalId',
  CHANNEL: 'channel',
  LOCATION: 'location'
};

export const ORDER_STATUS = {
  NEW: 'New',
  ACCEPTED: 'Accepted',
  COMPLETED: 'Completed',
  CANCELLED: 'Canceled',
  OVERDUE: 'Overdue',
  FUTURE: 'Future Order',
  READY: 'Ready'
};

export const AVAILABLE_ORDER_STATUSES = [
  'Scheduled',
  'Assigned',
  'OnRouteToPickup'
];

export const ORDER_SOURCE = {
  SAUCE: 'sauce',
  UBER: 'uber',
  DOORDASH: 'doordash',
  GRUBHUB: 'grubhub',
  SLICE: 'slice',
  EZCATER: 'ezcater',
  OTTER: 'otter',
  EXAMPLE_DSP: 'example_dsp',
  JET: 'jet',
  DELIVEROO: 'deliveroo',
  SKIP_THE_DISHES: 'skip_the_dishes',
  FLIP_DISH: 'flip_dish',
  CHOW_NOW: 'chow_now',
  SAUCE_DSP: 'sauce-dsp'
};

export const ORDER_SOURCE_NAMES = {
  sauce: 'Sauce',
  uber: 'UberEats',
  doordash: 'DoorDash',
  grubhub: 'GrubHub',
  slice: 'Slice',
  ezcater: 'EZCater'
};

export const ORDER_CANCELLATION_STATUS = {
  CANCELLED_SUCCESSFULLY: 'succeeded'
};

export const ORDER_TYPE = {
  ALL: 'All',
  PICKUP: 'PickUp',
  DELIVERY: 'Delivery',
  DINE_IN: 'DineIn',
  SAUCE_DELIVERY: 'SauceDelivery',
  SELF_DELIVERY: 'SelfDelivery'
};

export const ORDER_TYPES = {
  [ORDER_TYPE.PICKUP]: 'Pick up',
  [ORDER_TYPE.DELIVERY]: 'Delivery',
  [ORDER_TYPE.DINE_IN]: 'Dine in',
  [ORDER_TYPE.SAUCE_DELIVERY]: 'Sauce delivery',
  [ORDER_TYPE.SELF_DELIVERY]: 'Self delivery'
};

export const ORDER_FULFILLMENT = {
  ALL: 'All',
  PICKUP: 'PickUp',
  UBER_DELIVERY: 'UberDelivery',
  SAUCE_DELIVERY: 'SauceDelivery',
  DINE_IN: 'DineIn',
  SELF_DELIVERY: 'SelfDelivery',
  GRUBHUB_DELIVERY: 'GrubHubDelivery',
  DOORDASH_DELIVERY: 'DoorDashDelivery',
  SLICE_DELIVERY: 'SliceDelivery',
  EZCATER_DELIVERY: 'EZCaterDelivery'
};

export const ORDER_FULFILLMENT_NAME = {
  [ORDER_FULFILLMENT.PICKUP]: 'Pickup',
  [ORDER_FULFILLMENT.SAUCE_DELIVERY]: 'Sauce Delivery',
  [ORDER_FULFILLMENT.UBER_DELIVERY]: 'Uber Delivery',
  [ORDER_FULFILLMENT.GRUBHUB_DELIVERY]: 'GrubHub Delivery',
  [ORDER_FULFILLMENT.DOORDASH_DELIVERY]: 'DoorDash Delivery',
  [ORDER_FULFILLMENT.SLICE_DELIVERY]: 'Slice Delivery',
  [ORDER_FULFILLMENT.EZCATER_DELIVERY]: 'EZCater Delivery',
  [ORDER_FULFILLMENT.SELF_DELIVERY]: 'Self-delivery',
  [ORDER_FULFILLMENT.DINE_IN]: 'Dine in'
};

export const ORDER_PAYMENT_METHOD = {
  ALL: 'All',
  CREDIT_CARD: 'Credit Card',
  GOOGLE_PAY: 'Google Pay',
  APPLE_PAY: 'Apple Pay',
  DOORDASH: 'DoorDash',
  GRUBHUB: 'GrubHub',
  SLICE: 'Slice',
  EZCATER: 'EZCater',
  UBER_EATS: 'Uber Eats'
};

export const ORDER_PAYMENT_METHODS = {
  [ORDER_PAYMENT_METHOD.CREDIT_CARD]: 'Credit Card',
  [ORDER_PAYMENT_METHOD.GOOGLE_PAY]: 'Google Pay',
  [ORDER_PAYMENT_METHOD.APPLE_PAY]: 'Apple Pay',
  [ORDER_PAYMENT_METHOD.DOORDASH]: 'DoorDash',
  [ORDER_PAYMENT_METHOD.GRUBHUB]: 'GrubHub',
  [ORDER_PAYMENT_METHOD.UBER_EATS]: 'Uber Eats',
  [ORDER_PAYMENT_METHOD.SLICE]: 'Slice',
  [ORDER_PAYMENT_METHOD.EZCATER]: 'EZCater'
};

export const ORDER_MISC = {
  ALL: 'All',
  REFUND: 'Refunds'
};

export const ORDER_MISC_MANY = {
  [ORDER_MISC.REFUND]: 'Refunds'
};

export const FILTER_ORDER_SOURCE = {
  ALL: 'All',
  uber: 'uber',
  sauce: 'sauce',
  doordash: 'doordash',
  grubhub: 'grubhub',
  slice: 'slice',
  ezcater: 'ezcater'
};

export const FILTER_ORDER_SOURCES = {
  [FILTER_ORDER_SOURCE.uber]: 'UberEats',
  [FILTER_ORDER_SOURCE.sauce]: 'Sauce',
  [FILTER_ORDER_SOURCE.doordash]: 'DoorDash',
  [FILTER_ORDER_SOURCE.grubhub]: 'GrubHub',
  [FILTER_ORDER_SOURCE.slice]: 'Slice',
  [FILTER_ORDER_SOURCE.ezcater]: 'EZCater'
};

export const ORDER_TYPES_ALL = {
  [ORDER_TYPE.ALL]: 'All'
};

export const DELIVERY_PROVIDER_TYPE = {
  DISPATCH: 'dispatch',
  LOCATION: 'location',
  ORDER_PROVIDER: 'order provider'
};

export const DELIVERY_STATUS = {
  DELIVERED: 'Delivered',
  PICKED_UP: 'PickedUp',
  DROPOFF_ENROUTE: 'DropoffEnroute',
  DROPOFF_ARRIVED: 'DropoffArrived',
  RETURN_ENROUTE: 'ReturnEnroute',
  RETURNED: 'Returned',
  CANCELED: 'Canceled'
};

export const DELIVERY_RATEABLE_STATUSES = [
  DELIVERY_STATUS.DELIVERED,
  DELIVERY_STATUS.PICKED_UP,
  DELIVERY_STATUS.DROPOFF_ENROUTE,
  DELIVERY_STATUS.DROPOFF_ARRIVED,
  DELIVERY_STATUS.RETURN_ENROUTE,
  DELIVERY_STATUS.RETURNED
];

export const isDeliveryRateableStatus = (status, courierName) =>
  DELIVERY_RATEABLE_STATUSES.includes(status) ||
  (status === DELIVERY_STATUS.CANCELED && courierName);

export const EVENT_ORDER_TYPE_SELECT = {
  ALL: 'all',
  DELIVERY: 'delivery',
  SAUCE: 'sauce'
};

export const ORDER_CHANNELS = {
  STREAM_EVENT: 'stream event',
  SPOTON: 'spoton',
  GRUBHUB: 'grubhub',
  STOREFRONT: 'storefront',
  OTTER: 'otter'
};

export const EVENT_ORDER_TYPE_LIST = [
  {name: 'All Orders', value: EVENT_ORDER_TYPE_SELECT.ALL},
  {name: 'Delivery Orders', value: EVENT_ORDER_TYPE_SELECT.DELIVERY},
  {name: 'Sauce Orders', value: EVENT_ORDER_TYPE_SELECT.SAUCE}
];

export const DIFF_SECONDS_TO_READY = 210;

export default {ORDER};
